import { useCallback } from 'react';
import { updateLocationResult } from '@alltrails/explore-service/redux/exploreServiceSlice';
import { useAppDispatch, useAppSelector } from '../../../redux';
import { updateSelectedPOI } from '../../../redux/reducer';
import POIPinLarge from '../POIPinLarge/POIPinLarge';

const SelectedPOI = () => {
  const dispatch = useAppDispatch();
  const { selectedPOI } = useAppSelector(state => ({
    selectedPOI: state.map.selectedPOI
  }));

  const onPOIClick = useCallback(
    ev => {
      ev.preventDefault();
      dispatch(updateSelectedPOI(undefined));
      dispatch(updateLocationResult(undefined));
    },
    [dispatch]
  );

  return <POIPinLarge id="selected-poi" onClick={onPOIClick} poi={selectedPOI} shouldHidePhoto />;
};

export default SelectedPOI;
